// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__1lZIc","about":"footer_about__2GpIx","socialIcons":"footer_socialIcons__RQ_En","info":"footer_info__32CKn","downloads":"footer_downloads__47fwq"};